export const INACTIVE_TARGETING_STATE = Object.freeze({ status: 'inactive' });

/** Preserve a newer target request installed while the completed one resolved. */
export const finishResolvedTargeting = (current) =>
  current?.status === 'resolving' ? INACTIVE_TARGETING_STATE : current;
